module.exports = __webpack_public_path__ + "img/accommodation-4.bd227835.jpg";